import React, {CSSProperties} from "react";

interface CircularProgressArcProps {
  progress: number;
  style?: CSSProperties;
  className?: string;
}

const size = 100;
const strokeWidth = 8;
const CircularProgressArc: React.FC<CircularProgressArcProps> = ({progress, style, className}) => {
  const center = size / 2;
  const radius = center - strokeWidth / 2;
  const startAngleOffset = -Math.PI / 2;

  // Start point (always at 12 o'clock)
  const startX = center + radius * Math.cos(startAngleOffset);
  const startY = center + radius * Math.sin(startAngleOffset);

  const effectiveProgress = Math.min(0.9999, Math.max(0.01, progress));
  const endAngle = effectiveProgress * 2 * Math.PI + startAngleOffset;

  const endX = center + radius * Math.cos(endAngle);
  const endY = center + radius * Math.sin(endAngle);

  const largeArcFlag = effectiveProgress > 0.5 ? 1 : 0;
  const sweepFlag = 1;
  const pathData = `M ${startX} ${startY} A ${radius} ${radius} 0 ${largeArcFlag} ${sweepFlag} ${endX} ${endY}`;

  return (
    <svg
      viewBox={`0 0 ${size} ${size}`}
      style={style}
      className={className}
      aria-label={`Progress: ${Math.round(progress * 100)}%`}
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemin={0}
      aria-valuemax={1}
    >
      <circle cx={center} cy={center} r={radius} fill="none" strokeWidth={strokeWidth} />
      <path
        d={pathData}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CircularProgressArc;
